import { ReactNode } from 'react';

import { createFetchContext } from '../../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../../components/info/DisplayError';
import Loading from '../../../../../../components/info/Loading';
import { getAcademicOfferScheduleData } from '../../../api';
import { useAcademicOfferWizard } from '../../../context/AcademicOfferWizardContext';
import { NonStructuredAcademicOfferScheduleResponse } from '../../../types';

const {
  FetchProvider: AcademicOfferScheduleProvider,
  useFetch: useAcademicOfferScheduleData,
} = createFetchContext<
  number | string,
  NonStructuredAcademicOfferScheduleResponse
>();

interface Props {
  children: ReactNode;
}

function AcademicOfferScheduleContent({ children }: Readonly<Props>) {
  const { loading, error, data } = useAcademicOfferScheduleData();

  if (loading) {
    return (
      <div className="d-flex justify-content-center">
        <div className="m-auto">
          <Loading />
        </div>
      </div>
    );
  }

  if (error || !data) {
    return <DisplayError textBody={error?.code ?? 'CONNECTION'} />;
  }

  return <>{children}</>;
}

function AcademicOfferScheduleLoader({ children }: Readonly<Props>) {
  const { ceAcademicOfferId } = useAcademicOfferWizard();

  if (!ceAcademicOfferId) {
    return <DisplayError textBody="CONNECTION" />;
  }

  return (
    <AcademicOfferScheduleProvider
      request={getAcademicOfferScheduleData}
      fetchImmediately
      defaultQuery={ceAcademicOfferId}
    >
      <AcademicOfferScheduleContent>{children}</AcademicOfferScheduleContent>
    </AcademicOfferScheduleProvider>
  );
}

export { AcademicOfferScheduleLoader, useAcademicOfferScheduleData };
